//@ts-nocheck
import { Form } from "antd";
import { memo } from "react";
import "./FormComplete.less";
import FormProvider from "../../../context/FormContext/FormContext";
import FormBody from "../FormBody/FormBody";

//TODO: write initialData - it looks like this: [{"model":"AutoAccountingService","attribute":"email_account_id","value":"73"}]

type FormCompleteProps = {
   formId?: number;
   formData?: any;
   dataId?: number;
   isReadOnly?: boolean;
   form?: any;
   printable?: boolean;
   actionId?: number;
   recordId?: number;
   isSubmitVisible?: boolean;
   initialData?: any;
   formUuid?: string;
   defaultValues?: any;
   loadCallback?: any;
   saveCallback?: () => void;
   errorCallback?: () => void;
   isMessageForm?: boolean;
   additionalSaveData?: any;
   refreshForm?: () => void;
   hideAttachments?: boolean;
   formRef?: React.Ref<any>;
   attachmentLabelText?: string;
   areOnlyRequiredFieldsVisible?: boolean;
   label?: string;
};

let FormComplete = memo<FormCompleteProps>(
   ({
      formId, // Id of form that should be downloaded, not provided if there is actionId used
      formKey,
      formData, // Data for the form, in case its provided we dont need to download it
      dataId, // Id of data that should be downloaded, not provided if there is recordId used
      isReadOnly, // If form should be readonly
      form, // Form object from antd
      printable, // If form should be printable
      actionId, // Id of action that should be downloaded
      recordId, // Id of record that should be downloaded (used in runListAction)
      isSubmitVisible = true, // If submit button should be visible
      initialData, // Initial data for form
      formUuid, // Form uuid , unique id of form
      defaultValues, // Default values for form
      saveCallback, // Callback function after saving form using saveFormV2
      loadCallback, // Callback function after loading form data. We can pass any (onload) data to parent components
      isMessageForm, // If form is used in MessageItem,
      additionalSaveData, // Additional data that should be saved with form,
      refreshForm, // Function that can refresh form when called
      hideAttachments, // If attachments tab should be hidden
      formRef, // Ref of FormProvider
      attachmentLabelText = false,
      areOnlyRequiredFieldsVisible = false, // If true, only fields that meet conditions will be visible
      label,
   }) => {
      return (
         <>
            <FormProvider
               ref={formRef}
               formId={formId}
               formKey={formKey}
               formUuid={formUuid}
               dataId={dataId}
               isMessageForm={isMessageForm}
               isReadOnly={isReadOnly}
               isSubmitVisible={isSubmitVisible}
               form={form}
               printable={printable}
               actionId={actionId}
               recordId={recordId}
               initialData={initialData}
               saveCallback={saveCallback}
               loadCallback={loadCallback}
               defaultValues={defaultValues}
               additionalSaveData={additionalSaveData}
               formData={formData}
               hideAttachments={hideAttachments}
               //temporary solution, should be removed after implementing proper solution
               refreshForm={refreshForm}
            >
               <FormBody
                  attachmentLabelText={attachmentLabelText}
                  areOnlyRequiredFieldsVisible={areOnlyRequiredFieldsVisible}
                  label={label}
               />
            </FormProvider>
         </>
      );
   },
);
FormComplete = Form.create({ name: "form" })(FormComplete);
export default FormComplete;
